import ComponentBasePrototype from 'ComponentBasePrototype';
import { sendEventToGoogleAnalytics } from '../../../base/analytics/analyticsEvents';

export default class FlatProductCard extends ComponentBasePrototype {
  getRequiredModules() {
    return ['metrics'];
  }

  build() {
    this.sendMetricsDataOnClick();
  }

  sendMetricsDataOnClick() {
    this.node.on('click', () => {
      this.sendMetricsData();
    });
  }

  sendMetricsData() {
    sendEventToGoogleAnalytics({
      event: 'liiga_flat_product_card',
      eventCategory: 'liiga',
      eventAction: 'open liiga specific package',
    });
  }
}
